<template>
  <div class="row">

    <div class="col-12 pl-0">
      <h1 class="d-flex align-items-center">
        <span class="icon mr-2 icon-alle" aria-hidden="true"></span>
        {{ $t('views.roomList.title') }}
      </h1>
    </div>

    <loading-container :state="state">
      <link-back to="/" i18nMessage="common.backToDashboard" class="mt-0" />

      <div class="col-12 col-md-12 d-flex align-items-center justify-content-end mt-0">
        <button @click="changeSort()" class="btn btn-link text-positive btn-sortRooms mr-3" v-if="rooms.length > 1">
          <span class="icon mr-2 icon-select_pfeil" aria-hidden="true"></span>
          {{ $t('common.room.sortRooms') }}
        </button>
        <link-add-element i18nMessage="common.room.add" to="/room-add" />
      </div>

      <ul class="row list-unstyled mx-auto p-inline-start-0">
        <li v-for="(room, index) in rooms" :key="index" class="col-12 mb-3">
          <div class="d-flex row saal-overview-bearbeiten no-underline align-items-stretch">
            <div class="col-12 col-md-2 px-0 bg-darker">
              <room-image :room="room" />
            </div>
            <div class="col-12 col-md-10 d-flex align-items-center pr-1">
              <div class="saal-desc p-2">
                <h2>{{ room.name }}</h2>
                <p>{{ room.description }}</p>
              </div>
              <div class="ml-auto d-flex flex-column flex-md-row text-center" v-if="!showSort">
                <router-link :to="{ name: 'admin-room-edit', params: { id: room.id }}" class="icon-box d-flex flex-column justify-content-center p-2 m-2">
                  <span class="icon mb-1 icon-settings_profil_verwalten" aria-hidden="true"></span>
                  <span class="sr-only">{{ room.name }}</span>
                  <span>{{ $t('common.room.edit') }}</span>
                </router-link>

                <router-link :to="{ name: 'admin-room-edit-image', params: { id: room.id }}" class="icon-box d-flex flex-column justify-content-center p-2 m-2">
                  <span class="icon mb-1 icon-datei_bild" aria-hidden="true"></span>
                  <span>{{ $t('common.room.editImage') }}</span>
                </router-link>

                <router-link :to="{ name: 'admin-time-slots', params: { id: room.id }}" class="icon-box d-flex flex-column justify-content-center p-2 m-2">
                  <span class="icon mb-1 icon-kalender" aria-hidden="true"></span>
                  <span>{{ $t('views.roomList.configureTimeSlots') }}</span>
                </router-link>
              </div>

              <div class="ml-auto d-flex flex-column flex-md-row text-center" v-else>

                <button class="btn align-items-center icon-box d-flex flex-column justify-content-center p-2 m-2" @click="sortDown(index)" v-if="index < (rooms.length -1)" type="button">
                  <span class="icon mb-1 icon-navigation_pfeil_unten_gross" aria-hidden="true"></span>
                  <span class="sr-only">{{ $t('common.room.sortRoomsDown') }}</span>
                </button>

                <button class="btn align-items-center icon-box d-flex flex-column justify-content-center p-2 m-2" @click="sortUp(index)" v-if="index > 0" type="button">
                  <span class="icon mb-1 icon-navigation_pfeil_oben_gross" aria-hidden="true"></span>
                  <span class="sr-only">{{ $t('common.room.sortRoomsUp') }}</span>
                </button>

              </div>

            </div>
          </div>
        </li>
      </ul>

      <div class="col-12 col-md-12 d-flex align-items-center justify-content-end mt-0 px-0" v-if="showSort">
        <button @click="changeSort()" class="btn btn-brand1 px-5" type="button">
          {{ $t('common.room.sortRoomsEnd') }}
        </button>
      </div>

    </loading-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LoadingMixin from '@/mixins/LoadingMixin'

import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import LinkAddElement from '@/components/interaction/LinkAddElement.vue';
import RoomImage from '@/components/info/RoomImage.vue';
import LinkBack from '@/components/interaction/LinkBack.vue'
import { LoadingState } from '@/utils/loadingUtils';
import { Room } from '@/generated/openapi';
import { adminService } from '@/services/adminService';

export default defineComponent({
  name: 'RoomList',
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      rooms: [] as Room[],
      showSort: false
    }
  },
  components: {
    LoadingContainer,
    LinkAddElement,
    RoomImage,
    LinkBack
  },
  methods:{
    changeSort(){
      this.showSort = !this.showSort;
    },
    swapArrayElements (arr: any, indexA: number, indexB: number) {
      let temp = arr[indexA];
      arr[indexA] = arr[indexB];
      arr[indexB] = temp;
    },
    sortUp(idx: number){
      if(idx !== 0){
        let idx_new = idx - 1;
        this.swapArrayElements(this.rooms, idx, idx_new);

        adminService.orderRooms(this.rooms[idx_new].id,idx_new).then( () => {
          this.state = LoadingState.success
        }).catch(this.handleError)
      }
    },
    sortDown(idx: number){
      if(idx < (this.rooms.length-1)){
        let idx_new = idx + 1;
        this.swapArrayElements(this.rooms, idx, idx_new);

        adminService.orderRooms(this.rooms[idx_new].id,idx_new).then( () => {
          this.state = LoadingState.success
        }).catch(this.handleError)
      }
    },
  },
  created() {
    adminService.getAllRooms().then(rooms => {
      this.rooms = rooms
      this.state = LoadingState.success
    }).catch(this.handleError)
  }
});
</script>
